import { FC, useEffect, useState } from 'react';

import { updateChargeZero } from '../../../../../../services/services';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../../utils/displayNudosStandardNotifications';
import GenericLoader from '../../../../../../components/GenericLoader';
import CheckArrowIcon from '../../../../../../assets/images/catalogue/CheckArrowIcon';
import { getNudosData } from '../../../../../../utils/getNudosData';

import './LogisticServiceLeaveChargeAtZero.scss';

const LogisticServiceLeaveChargeAtZero: FC<ILogisticServiceLeaveChargeAtZero> = ({
  showComponent,
  isPaymentZero,
  logisticsServiceId,
  updateWithLoaders,
  careShowDoesNotCoverTheEntirePayment,
  listenToExternalChange
}: ILogisticServiceLeaveChargeAtZero) => {
  const nudosData = getNudosData();

  const [isSelect, setIsSelect] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const showCareData = careShowDoesNotCoverTheEntirePayment;
  const userId = Number(nudosData?.userData?.id);

  const labelCare = showCareData
    ? 'Nudos Care no cubre todo el servicio, es necesario un pago'
    : 'No es necesario un pago, dejar en cobro cero';

  const handleChargeCero = async () => {
    if (!userId) return;
    setLoading(true);
    try {
      await updateChargeZero(logisticsServiceId, { userId });
      updateWithLoaders?.();
      displaySuccessNotification({ customJSXMessage: <>Se actualizó con exito</> });
    } catch {
      displayErrorNotification();
    } finally {
      setLoading(false);
    }
  };

  const defaultValue = () => setIsSelect(isPaymentZero);

  const handleExternalchange = (state: boolean) => {
    if (!listenToExternalChange) return;
    setIsSelect(state);
    listenToExternalChange(state);
  };

  const handleUpdateAction = () => {
    if (!loading) {
      careShowDoesNotCoverTheEntirePayment ? handleExternalchange(!isSelect) : handleChargeCero();
    }
  };

  const checkElement = () => {
    if (loading)
      return (
        <div className="checkLoading">
          <GenericLoader borderWidth={1} sizeLoader={8} pb={5} />
        </div>
      );
    if (isSelect) {
      return (
        <div className="selectItem">
          <CheckArrowIcon />
        </div>
      );
    }
    return <div className="noSelect" />;
  };

  useEffect(() => {
    defaultValue();
  }, [isPaymentZero]);

  if (!showComponent) return <></>;

  return (
    <div id="logisticServiceLeaveChargeAtZero">
      <div className="checkBoxContainer" onClick={handleUpdateAction}>
        {checkElement()}
      </div>
      <div className="styleText">{labelCare || ''}</div>
    </div>
  );
};

export default LogisticServiceLeaveChargeAtZero;

interface ILogisticServiceLeaveChargeAtZero {
  showComponent: boolean;
  logisticsServiceId: number;
  isPaymentZero: boolean;
  updateWithLoaders?: () => void;
  careShowDoesNotCoverTheEntirePayment?: boolean;
  listenToExternalChange?: (state: boolean) => void;
}
